// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type UmsatzmengenAuswertung } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetUmsatzMengenAuswertungByBaustellenId(): (
  baustellenId: string,
  richtung: string
) => Promise<UmsatzmengenAuswertung> {
  const getAPI = useGetApi();
  return useCallback(
    async (baustellenId, richtung) =>
      (await getAPI()).umsatz.getUmsatzMengenAuswertungByBaustellenId({
        baustellenId,
        richtung,
      }),
    [getAPI]
  );
}
